import { ReactComponent as LockImage } from '../../../../images/lock.svg';
import styles from './UserSettingsAndAccessForm.module.css';
import { dataTestId } from './common';
import { formatPermissionLabel } from 'admin/utils/parsePermissionsLabels';
import { PermissionKey } from 'js-sdk/src/types/Persona';
import { Checkbox } from 'admin/shared-components/Checkbox/Checkbox';

type AccessCheckboxProps = {
  isLockedByPersona: boolean;
  permission: string;
  blockedByPersonaText: string;
  orgPermissions: Map<PermissionKey, { name: string; description: string }>;
  disableAll: boolean;
  checked: boolean;
  onClick: (checked: boolean) => void;
};
const AccessCheckbox: React.FC<AccessCheckboxProps> = ({
  isLockedByPersona,
  permission,
  blockedByPersonaText,
  orgPermissions,
  disableAll,
  checked,
  onClick,
}) => {
  return (
    <div className={styles.settingsGroupGridItem} key={permission}>
      <div
        className={styles.container}
        data-testid={dataTestId('permission', formatPermissionLabel(permission))}
      >
        <div className={styles.left}>
          <div className={styles.title}>{formatPermissionLabel(permission)}</div>
          {isLockedByPersona && (
            <div className={styles.lockDesc}>
              <LockImage />
              {blockedByPersonaText}
            </div>
          )}
          <div className={styles.description}>
            {orgPermissions.get(permission as PermissionKey)?.description}
          </div>
        </div>
        <div className={styles.right}>
          <Checkbox
            disabled={disableAll || isLockedByPersona}
            checked={checked}
            onClick={onClick}
            multiple
            isLabelClickable={!disableAll || isLockedByPersona}
            dataTestId={permission}
          />
        </div>
      </div>
    </div>
  );
};

export default AccessCheckbox;
